"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETypeService = exports.EUserType = void 0;
var EUserType;
(function (EUserType) {
    EUserType["Responsavel"] = "R";
    EUserType["Aluno"] = "A";
    EUserType["LoginExtra"] = "E";
    EUserType["Professor"] = "P";
    EUserType["UsuarioSistema"] = "U";
    EUserType["UsuarioInterno"] = "I";
})(EUserType = exports.EUserType || (exports.EUserType = {}));
var ETypeService;
(function (ETypeService) {
    ETypeService[ETypeService["BuscaUsuario"] = 0] = "BuscaUsuario";
    ETypeService[ETypeService["BuscaUsuarioParaAutenticacao"] = 1] = "BuscaUsuarioParaAutenticacao";
    ETypeService[ETypeService["S3Upload"] = 2] = "S3Upload";
    ETypeService[ETypeService["S3LerURL"] = 3] = "S3LerURL";
    ETypeService[ETypeService["S3RemoveURL"] = 4] = "S3RemoveURL";
    ETypeService[ETypeService["GetConfig"] = 5] = "GetConfig";
    ETypeService[ETypeService["PutConfig"] = 6] = "PutConfig";
})(ETypeService = exports.ETypeService || (exports.ETypeService = {}));
